import { Box, Container, Flex } from '@energiebespaarders/symbols';
import Head from 'next/head';
import { Element as Anchor } from 'react-scroll';
import Process from '~/components/HomePage/Process';
import PartnerHero from '~/envPartner/PartnerLogin/SamenHero';
import useRedirectOnAuthenticated from '~/hooks/useRedirectOnAuthenticated';
import type { Page } from '~/types/next';

const PartnerLogin: Page = () => {
  useRedirectOnAuthenticated('PartnerAgent', '/samen');
  return (
    <div>
      <Head>
        <title key="title">Login bij partnerportaal</title>
        <link
          rel="canonical"
          href={'https://energiebespaarders.nl/samen/login'}
          key="meta-canonical"
        />
      </Head>
      <Flex flexWrap="wrap">
        <Box width={1}>
          <PartnerHero />
        </Box>
        <Box width={1}>
          <Anchor name="how">
            <Container py={10}>
              <Process />
            </Container>
          </Anchor>
        </Box>
      </Flex>
    </div>
  );
};

export default PartnerLogin;
